var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 0 12 12",
    id: "meteor-icon-kit__regular-grip-vertical-s",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C0.44772 2 0 1.55228 0 1C0 0.44772 0.44772 0 1 0C1.5523 0 2 0.44772 2 1C2 1.55228 1.5523 2 1 2zM1 7C0.44772 7 0 6.5523 0 6C0 5.4477 0.44772 5 1 5C1.5523 5 2 5.4477 2 6C2 6.5523 1.5523 7 1 7zM1 12C0.44772 12 0 11.5523 0 11C0 10.4477 0.44772 10 1 10C1.5523 10 2 10.4477 2 11C2 11.5523 1.5523 12 1 12zM5 2C4.4477 2 4 1.55228 4 1C4 0.44772 4.4477 0 5 0C5.5523 0 6 0.44772 6 1C6 1.55228 5.5523 2 5 2zM5 7C4.4477 7 4 6.5523 4 6C4 5.4477 4.4477 5 5 5C5.5523 5 6 5.4477 6 6C6 6.5523 5.5523 7 5 7zM5 12C4.4477 12 4 11.5523 4 11C4 10.4477 4.4477 10 5 10C5.5523 10 6 10.4477 6 11C6 11.5523 5.5523 12 5 12z",
    fill: "#758CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.37e54e8be8e0a19343cff5cc94fad660.svg";
export { ForwardRef as ReactComponent };